import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  donations: [],
};

const DonationSlice = createSlice({
  name: "Donation",
  initialState,
  reducers: {
    DontaionRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.donations = [];
    },
    DonationSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.donations = action.payload;
    },

    DonationFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.donations = [];
    },
    
  },
});

export const DonationActions = DonationSlice.actions;
export default DonationSlice;
